import { render } from "./settings.vue?vue&type=template&id=21c7d23e&scoped=true"
import script from "./settings.vue?vue&type=script&lang=js"
export * from "./settings.vue?vue&type=script&lang=js"

import "./settings.vue?vue&type=style&index=0&id=21c7d23e&scoped=true&lang=css"
import "./settings.vue?vue&type=style&index=1&id=21c7d23e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21c7d23e"]])

export default __exports__